<section class="login-container">
  <app-login-carousel></app-login-carousel>

  @if (action && action == 'passwort-erfolgreich-gesetzt') {
    <div class="success-message">
      Ihr neues Passwort wurde gespeichert. Geben Sie Ihren Benutzernamen und Ihr Passwort hier ein.
    </div>
  }

  @if (maintenance) {
    <div class="notification d-flex jcse aic p-m my-l warn">
      <mat-icon fontSet="material-symbols-outlined" color="primary" aria-hidden="false">error</mat-icon>
      <div class="ml-m">
        Aufgrund laufender Wartungsarbeiten ist der Login derzeit vorübergehend deaktiviert.
        Ab ca. <b>22:00 Uhr</b> steht Ihnen das Apothekenportal wieder wie gewohnt zur Verfügung.
        <br><br>
        Vielen Dank für Ihr Verständnis. <br>
        <b>Ihr Hageda-Stumpf Team</b>
      </div>
    </div>
  } @else {
    <div class="login-page">
      <section class="login-logo">
        @if (isDev()) {
        <span>DEV - Umgebung</span>
        }
        @if (isQa()) {
          <span>QA - Umgebung</span>
        }
        <img
          src="../../assets/images/hageda-stumpf-logo.svg" alt="Hageda-Stumpf Apothekenportal"/>
      </section>

      <div class="login-section">
        <h2>Anmeldung</h2>

        @if (loginError) {
          <mat-card class="mb-l">
            <mat-card-content class="p-s">
              <div class="jcsb d-flex aic">
                <mat-icon fontSet="material-symbols-outlined" aria-hidden="false" color="error" class="mr-s">
                  error_outline
                </mat-icon>
                <p class="my-s w-90">
                  Ihr Login war leider nicht erfolgreich. Bitte wiederholen Sie die Eingabe und achten Sie auf die
                  korrekte Schreibweise von Benutzername und Passwort.
                </p>
              </div>
            </mat-card-content>
          </mat-card>
        }

        <form class="d-flex flex-column" [formGroup]="loginForm" (submit)="login()">
          <mat-form-field appearance="outline">
            <mat-label>Benutzername</mat-label>
            <input matInput
                   formControlName="username"
                   name="username"
                   tabindex="1"
                   autocomplete="username">

            @if (username.hasError('noIdf')) {
              <mat-error>
                Die Eingabe Ihrer IDF-Nummer ist nicht möglich. Bitte geben Sie Ihren Benutzernamen
                ein, z. B. max.mustermann.
              </mat-error>
            }
            @if (username.hasError('noEmail')) {
              <mat-error>
                Die Eingabe Ihrer Emailadresse ist nicht möglich. Bitte geben Sie Ihren
                Benutzernamen ein, z. B. max.mustermann.
              </mat-error>
            }
            @if (username.hasError('pattern')) {
              <mat-error>
                Das Benutzernamenformat ist falsch (z. B. max.mustermann)
              </mat-error>
            }
          </mat-form-field>

          <mat-form-field appearance="outline">
            <mat-label>Passwort</mat-label>
            <input matInput
                   [type]="hide ? 'password' : 'text'"
                   formControlName="password"
                   autocomplete="current-password"
                   name="password"
                   tabindex="2">
            <button mat-icon-button
                    matSuffix
                    type="button"
                    (click)="hide = !hide"
                    [attr.aria-label]="'Hide password'"
                    [attr.aria-pressed]="hide">
              <mat-icon fontSet="material-symbols-outlined" aria-hidden="false">
                {{ hide ? 'visibility_off' : 'visibility' }}
              </mat-icon>
            </button>
          </mat-form-field>

          <div class="d-flex jcsb">
            <a mat-button routerLink="/forgotten-password">Passwort vergessen?</a>
            <button mat-flat-button color="primary" tabindex="3" [disabled]="!loginForm.valid">Anmelden</button>
          </div>
        </form>
      </div>

      <div class="register-section">
        <h2 class="title">Registrierung</h2>
        <p>
          Registrieren Sie sich als Hageda-Stumpf Großhandelskunde kostenfrei und profitieren Sie von den zahlreichen
          Vorteilen des Apothekenportals.
        </p>
        <a mat-flat-button routerLink="/register" tabindex="4">zur Registrierung</a>
        <p>Sie benötigen Unterstützung?</p>
        <a mat-flat-button routerLink="open/page/hgf" tabindex="5">zu den Häufig gestellte Fragen</a>
      </div>
    </div>
  }
</section>
